// extracted by mini-css-extract-plugin
export default {"container":"Keyboard_container__VCOno","language_btn":"Keyboard_language_btn__5Adjo","pressed_btn":"Keyboard_pressed_btn__tVH7t"};